import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBackendAuth } from './BackendAuthProvider.jsx';
import LoginButton from './LoginButton.jsx';

const UnauthenticatedTemplate = () => {
  const { isAuthenticated, error } = useBackendAuth();
  const { t } = useTranslation('auth');

  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {t('login.title')}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            {t('login.subtitle')}
          </p>
          <p className="mt-2 text-center text-xs text-green-600">
            {t('login.backendNote')}
          </p>
          {error && (
            <p className="mt-2 text-center text-xs text-red-600">
              {error}
            </p>
          )}
        </div>
        <div className="flex justify-center">
          <LoginButton />
        </div>
      </div>
    </div>
  );
};

export default UnauthenticatedTemplate;
